import { createContext, useContext } from 'react';

import { UseAutocompleteReturn } from './useAutocomplete';

export const AutocompleteContext = createContext<UseAutocompleteReturn | null>(
  null
);

export function useAutocompleteContext() {
  const context = useContext(AutocompleteContext);

  if (!context) {
    throw new Error(
      'useAutocompleteContext must be used inside of AutocompleteContext'
    );
  }

  return context;
}
